import { Fragment } from 'react';
import TableBodyRow from './TableBodyRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableBodyFeatureGroup = ({
  apiNames,
  groupFeatures
}) => {
  const hasMatchingApiName = feature => {
    return feature.productApiNames.some(productApiName => apiNames.includes(productApiName));
  };

  // First filter: Only include groups where the parent feature has a matching API name
  const filteredGroupFeatures = groupFeatures.filter(feature => hasMatchingApiName(feature.parentFeature)).map(feature => {
    // Second filter: For each group, filter the children to only include those with matching API names
    return {
      parentFeature: feature.parentFeature,
      childrenFeatures: feature.childrenFeatures.filter(hasMatchingApiName)
    };
  });
  return filteredGroupFeatures.map(feature => {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(TableBodyRow, {
        feature: feature.parentFeature,
        isChildFeature: false,
        apiNames: apiNames
      }), feature.childrenFeatures.map(childFeature => /*#__PURE__*/_jsx(TableBodyRow, {
        feature: childFeature,
        isChildFeature: true,
        apiNames: apiNames
      }, childFeature.shortName))]
    }, feature.parentFeature.shortName);
  });
};
export default TableBodyFeatureGroup;